import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Products from './pages/Products'
import About from './pages/About'
import Quote from './pages/Quote'
import Contact from './pages/Contact'
import RollFormingMachines from './pages/products/RollFormingMachines'
import Tooling from './pages/products/Tooling'
import UncoilersPresses from './pages/products/UncoilersPresses'
import EquipmentInventory from './pages/products/EquipmentInventory'
import Admin from './pages/Admin'
import './styles/App.css'

function App() {
  const location = useLocation()
  const isAdminPage = location.pathname === '/admin'

  return (
    <div className="App">
      {!isAdminPage && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/roll-forming-machines" element={<RollFormingMachines />} />
          <Route path="/products/tooling" element={<Tooling />} />
          <Route path="/products/uncoilers-presses" element={<UncoilersPresses />} />
          <Route path="/products/used-equipment" element={<EquipmentInventory />} />
          <Route path="/about" element={<About />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdminPage && <Footer />}
    </div>
  )
}

export default App